import { render, staticRenderFns } from "./ColumnController.vue?vue&type=template&id=d04e4aa2&"
import script from "./ColumnController.vue?vue&type=script&lang=ts&"
export * from "./ColumnController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports